import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatCard } from '@angular/material/card';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgToastService } from 'ng-angular-popup';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-expression-of-interest',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatCard,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './expression-of-interest.component.html',
  styleUrl: './expression-of-interest.component.css',
})
export class ExpressionOfInterestComponent implements OnInit {
  formGroup: FormGroup;
  expressionData: any;
  isUpdate = false;
  eoi_id: any;

  constructor(
    private fb: FormBuilder,
    private toast: NgToastService,
    private projectsService: ProjectsService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const isEdit = localStorage.getItem('isEdit');

    const projectId = localStorage.getItem('projectId');

    if (isEdit === 'true' && projectId) {
      this.getExpressionOfInterest();
    }

    this.formGroup = this.fb.group({
      // Applicant Details
      company_name: ['', Validators.required],
      contact_person: ['', Validators.required],
      company_reg_no: ['', Validators.required],
      contact_person_position: ['', Validators.required],
      company_vat_no: ['', Validators.required],
      email: ['', [Validators.email]],
      website: [''],
      phone: [''],
      address: [''],
      city: [''],
      state: [''],
      country: [''],
      zip: [''],

      // Scope of Interest
      nature_of_service: ['', Validators.required],
      expected_start_date: [''],
      type_of_project: [''],
      expected_end_date: [''],
      project_location: [''],
      estimation_price: [''],

      // Experience & Capability
      experience: [''],
      qualifications: [''],
      team_composition: [''],

      // Compliance & Policies
      health_safety_environmental_policy: [''],
      quality_assurance_cert_attach: [''],
      conflict_of_interest: [''],

      // Additional Information
      description: [''],

      // Declaration
      authorized_representative: ['', Validators.required],
      authorized_representative_position: ['', Validators.required],
      signature: ['', Validators.required],
      date: ['', Validators.required],
      status: 'pending',
    });
  }

  prepareDataToSubmit() {
    const dataToSubmit = new FormData();

    // Dynamically append all form controls to FormData
    Object.keys(this.formGroup.controls).forEach((key) => {
      const value = this.formGroup.get(key)?.value;
      if (value !== null && value !== undefined && value !== '') {
        dataToSubmit.append(key, value);
      }
    });

    return dataToSubmit;
  }

  onSubmit(): void {
    if (this.isUpdate) {
      if (this.formGroup.valid) {
        const dataToSubmit = this.prepareDataToSubmit();

        this.projectsService
          .updateProjectExpressions(dataToSubmit, this.eoi_id)
          .subscribe({
            next: () => {
              this.toast.success('Application filed successfuly', 'SUCCESS');
              console.log('Form Data:', this.formGroup.value);
              // this.router.navigate(['/expression-of-interest-view']);
            },
            error: (error: any) => {
              console.error('Failed to submit application:', error);
              this.toast.danger(error.error.message, 'DANGER', 4000);
            },
          });
      } else {
        this.toast.warning('Please fill the required fields', 'WARNING');
        this.formGroup.markAllAsTouched(); // Highlights all invalid fields
      }
    } else {
      if (this.formGroup.valid) {
        const dataToSubmit = this.prepareDataToSubmit();

        this.projectsService.projectExpressions(dataToSubmit).subscribe({
          next: () => {
            this.toast.success('Application filed successfuly', 'SUCCESS');
            console.log('Form Data:', this.formGroup.value);
            // this.router.navigate(['/expression-of-interest-view']);
          },
          error: (error: any) => {
            console.error('Failed to submit application:', error);
            this.toast.danger(error.error.message, 'DANGER', 4000);
          },
        });
      } else {
        this.toast.warning('Please fill the required fields', 'WARNING');
        this.formGroup.markAllAsTouched(); // Highlights all invalid fields
      }
    }
  }

  getControl(controlName: string) {
    return this.formGroup.get(controlName);
  }

  getExpressionOfInterest() {
    this.projectsService.getProjectExpressions().subscribe({
      next: (data) => {
        this.expressionData = data.data[0];
        console.log(
          'Expression of interest data fetched successfully:',
          this.expressionData
        );

        // Patch the form with the response data
        if (this.expressionData) {
          this.eoi_id = this.expressionData.id;
          this.formGroup.patchValue({
            company_name: this.expressionData.company_name || '',
            contact_person: this.expressionData.contact_person || '',
            company_reg_no: this.expressionData.company_reg_no || '',
            contact_person_position:
              this.expressionData.contact_person_position || '',
            company_vat_no: this.expressionData.company_vat_no || '',
            email: this.expressionData.email || '',
            website: this.expressionData.website || '',
            phone: this.expressionData.phone || '',
            address: this.expressionData.address || '',
            city: this.expressionData.city || '',
            state: this.expressionData.state || '',
            country: this.expressionData.country_id || '',
            zip: this.expressionData.zip || '',
            nature_of_service: this.expressionData.nature_of_service || '',
            expected_start_date: this.expressionData.expected_start_date || '',
            type_of_project: this.expressionData.type_of_project || '',
            expected_end_date: this.expressionData.expected_end_date || '',
            project_location: this.expressionData.project_location || '',
            estimation_price: this.expressionData.estimation_price || '',
            experience: this.expressionData.experience || '',
            qualifications: this.expressionData.qualifications || '',
            team_composition: this.expressionData.team_composition || '',
            health_safety_environmental_policy:
              this.expressionData.health_safety_environmental_policy || '',
            quality_assurance_cert_attach:
              this.expressionData.quality_assurance_cert_attach || '',
            conflict_of_interest:
              this.expressionData.conflict_of_interest || '',
            description: this.expressionData.description || '',
            authorized_representative:
              this.expressionData.authorized_representative || '',
            authorized_representative_position:
              this.expressionData.authorized_representative_position || '',
            signature: this.expressionData.signature || '',
            date: this.expressionData.date || '',
            status: this.expressionData.status || 'pending',
          });

          this.isUpdate = true;
        }
      },
      error: (error) => {
        console.error('Error fetching expression of interest data:', error);
      },
    });
  }
}
